module.exports = __webpack_public_path__ + "static/assets/bc487cde787d1a887f7d5494e707ef46.svg";